module.exports = __webpack_public_path__ + "img/10021.ebc78959.png";